export const getFormattedUsage = (e) =>  e.replace(/,/g, '')
